import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../../lib/api-client";
import type { components } from "../../lib/api-types.gen";

export type VersionResponse = components["schemas"]["VersionResponse"];

/*
 * The own display name moved to the accounts-rbac module ([F-029]): it is
 * changed on the account page through PATCH /access/me/display-name, with the
 * [DO-012] rules - not through the tool's PATCH /me any more.
 */

/** GET /version - the API's build information, for the about dialog (CD-010). */
export function useApiVersion(enabled: boolean) {
  return useQuery({
    queryKey: ["system", "version"],
    queryFn: () => apiFetch<VersionResponse>("/version"),
    enabled,
    staleTime: 5 * 60_000,
  });
}
